import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
    selector: 'app-text-comparison',
    templateUrl: './text-comparison.component.html',
    styleUrls: ['./text-comparison.component.scss'],
    standalone: false
})
export class TextComparisonComponent implements OnInit {

  @Input() firstText: string = '';
  @Input() secondText: string = '';
  diffHtml: SafeHtml = '';

  constructor(
    private readonly sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.compareTexts();
  }

  private compareTexts() {
    const firstText = JSON.parse(this.firstText);
    const secondText = JSON.parse(this.secondText);
    const rawHtml = this.generateReadableDiffs(firstText, secondText);
    this.diffHtml = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  }

  private generateReadableDiffs(firstText: any, secondText: any): string {
    const differences: string[] = [];
    const allKeys = new Set([...Object.keys(firstText), ...Object.keys(secondText)]);

    allKeys.forEach(key => {
      const firstTextValue = firstText[key] !== undefined && firstText[key] !== "" ? firstText[key] : null;
      const secondTextValue = secondText[key] !== undefined && secondText[key] !== "" ? secondText[key] : null;

      if (firstTextValue !== secondTextValue) {
        differences.push(`
          <tr>
            <td><b>${this.formatKey(key)}</b></td>
            <td style="color: #f44336; text-decoration: line-through;">${firstTextValue}</td>
            <td style="color: #008000;">${secondTextValue}</td>
          </tr>
        `);
      } else {
        differences.push(`
          <tr>
            <td>${this.formatKey(key)}</td>
            <td>Same / Equal</td>
            <td>Same / Equal</td>
          </tr>
        `);
      }
    });

    return `
      <table style="width: 100%; border-collapse: separate; border-spacing: 5pt;">
        <thead>
          <tr>
            <th style="text-align: left; width: 33%">Field</th>
            <th style="text-align: left; width: 33%;">Imperia Carrier</th>
            <th style="text-align: left; width: 33%;">Stage Carrier</th>
          </tr>
        </thead>
        <tbody>
            ${differences.length > 0 ? differences.join('') : '<tr><td colspan="3">No differences found</td></tr>'}
        </tbody>
      </table>
    `;
  }

  private formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, " $1")  // Add spaces before uppercase letters
      .replace(/_/g, " ")          // Replace underscores with spaces
      .replace(/\bId\b/g, "ID")    // Fix "Id" to "ID"
      .trim();                     // Remove extra spaces
  }

}
